const isSameLocation = (A, B) => {
  if (!A || !B)
    return false;
  const coordinatesA = [A.latitude, A.longitude].filter(Boolean);
  const coordinatesB = [B.latitude, B.longitude].filter(Boolean);
  if (coordinatesA.length === 2 || coordinatesB.length === 2)
    return coordinatesA[0] === coordinatesB[0] && coordinatesA[1] === coordinatesB[1];
  return A.name === B.name && A.countryCode === B.countryCode;
};
var isSameLocation_default = isSameLocation;
export {
  isSameLocation_default as default
};
